'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _NodeResolver = require('./NodeResolver');

var _NodeResolver2 = _interopRequireDefault(_NodeResolver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

class ScrollCaptor extends _react.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.isBottom = false, this.isTop = false, this.cancelScroll = event => {
      event.preventDefault();
      event.stopPropagation();
    }, this.handleEventDelta = (event, delta) => {
      const {
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
      } = this.props;
      const { scrollTop, scrollHeight, clientHeight } = this.scrollTarget;
      const target = this.scrollTarget;
      const isDeltaPositive = delta > 0;
      const availableScroll = scrollHeight - clientHeight - scrollTop;
      let shouldCancelScroll = false;

      // reset bottom/top flags
      if (availableScroll > delta && this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        this.isBottom = false;
      }
      if (isDeltaPositive && this.isTop) {
        if (onTopLeave) onTopLeave(event);
        this.isTop = false;
      }

      // bottom limit
      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !this.isBottom) {
          onBottomArrive(event);
        }
        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        this.isBottom = true;

        // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !this.isTop) {
          onTopArrive(event);
        }
        target.scrollTop = 0;
        shouldCancelScroll = true;
        this.isTop = true;
      }

      // cancel scroll
      if (shouldCancelScroll) {
        this.cancelScroll(event);
      }
    }, this.onWheel = event => {
      this.handleEventDelta(event, event.deltaY);
    }, this.onTouchStart = event => {
      // set touch start so we can calculate touchmove delta
      this.touchStart = event.changedTouches[0].clientY;
    }, this.onTouchMove = event => {
      const deltaY = this.touchStart - event.changedTouches[0].clientY;
      this.handleEventDelta(event, deltaY);
    }, this.getScrollTarget = ref => {
      this.scrollTarget = ref;
    }, _temp;
  }

  componentDidMount() {
    this.startListening(this.scrollTarget);
  }
  componentWillUnmount() {
    this.stopListening(this.scrollTarget);
  }
  startListening(el) {
    // bail early if no scroll available
    if (el.scrollHeight <= el.clientHeight) return;

    // all the if statements are to appease Flow 😢
    if (typeof el.addEventListener === 'function') {
      el.addEventListener('wheel', this.onWheel, false);
    }
    if (typeof el.addEventListener === 'function') {
      el.addEventListener('touchstart', this.onTouchStart, false);
    }
    if (typeof el.addEventListener === 'function') {
      el.addEventListener('touchmove', this.onTouchMove, false);
    }
  }
  stopListening(el) {
    // bail early if no scroll available
    if (el.scrollHeight <= el.clientHeight) return;

    // all the if statements are to appease Flow 😢
    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('wheel', this.onWheel, false);
    }
    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('touchstart', this.onTouchStart, false);
    }
    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('touchmove', this.onTouchMove, false);
    }
  }

  render() {
    return _react2.default.createElement(
      _NodeResolver2.default,
      { innerRef: this.getScrollTarget },
      this.props.children
    );
  }
}

class ScrollCaptorSwitch extends _react.Component {
  render() {
    const _props = this.props,
          { isEnabled } = _props,
          props = _objectWithoutProperties(_props, ['isEnabled']);
    return isEnabled ? _react2.default.createElement(ScrollCaptor, props) : this.props.children;
  }
}
exports.default = ScrollCaptorSwitch;
ScrollCaptorSwitch.defaultProps = { isEnabled: true };